import PhoneNumberInput from './PhoneNumberInput';

export default PhoneNumberInput;


// WEBPACK FOOTER //
// ./src/components/PhoneNumberInput/index.js